import { DisplayType } from 'domains/models/event_type_location/displayType';
import { PhoneType } from 'domains/models/event_type_location/phoneType';

import { z } from 'zod';

export const DisplayTypeEnum = z.nativeEnum(DisplayType);
export const PhoneTypeEnum = z.nativeEnum(PhoneType);
